import React, { Component } from 'react';
import classnames from 'classnames';
import { ConfirmationModal, ConfirmationModalProps } from '../base';
import { GenConfirmationTemplate } from '../../../templates/confirmation-template/genesis';

import styles from './gen-confirmation-modal.module.scss';

export class GenConfirmationModal extends Component<ConfirmationModalProps> {
	state = { isClosing: false };

	componentWillReceiveProps(nextProps: ConfirmationModalProps) {
		const prevProps = this.props;

		if (prevProps.isOpen !== nextProps.isOpen) {
			this.setState({ isClosing: !nextProps.isOpen });
		}
	}

	handleCancel = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		this.setState({ isClosing: true });

		const { onCancel } = this.props;
		if (onCancel) setTimeout(() => onCancel(e), 300);
	};

	handleConfirm = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		this.setState({ isClosing: true });

		const { onConfirm } = this.props;
		if (onConfirm) setTimeout(() => onConfirm(e), 300);
	};

	render() {
		const { className } = this.props;
		const { isClosing } = this.state;

		return (
			<ConfirmationModal
				{...this.props}
				className={classnames(
					styles.genConfirmationModal,
					isClosing && styles.isClosing,
					className
				)}
				overlayClassName={styles.genConfirmationBackdrop}

				Template={GenConfirmationTemplate}
				onCancel={this.handleCancel}
				onConfirm={this.handleConfirm}
			/>
		);
	}
}
